import { render, staticRenderFns } from "./IngestionPicker.vue?vue&type=template&id=58dae961&scoped=true"
import script from "./IngestionPicker.vue?vue&type=script&lang=ts"
export * from "./IngestionPicker.vue?vue&type=script&lang=ts"
import style0 from "./IngestionPicker.vue?vue&type=style&index=0&id=58dae961&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dae961",
  null
  
)

export default component.exports